
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"m21.546 5.09 10.87 15.063c2.22 3.12 3.675 5.955 3.675 9.665 0 8.033-6.512 14.546-14.546 14.546C13.513 44.364 7 37.85 7 29.818c0-3.71 1.455-6.545 3.675-9.665l10.87-15.062Zm-8.273 23.274c0-1.927.535-3.729 1.465-5.265.284 7.593 6.388 13.697 13.981 13.982a10.135 10.135 0 0 1-5.265 1.464c-5.623 0-10.181-4.558-10.181-10.181Z","fill":"#D0EFEC"}}),_c('path',{staticClass:"i-Union",attrs:{"d":"M14.07 18.248 24.5 3.852l10.43 14.396v.002c2.19 3.064 3.57 5.775 3.57 9.306 0 7.7-6.266 13.944-14 13.944s-14-6.245-14-13.944c0-3.53 1.38-6.242 3.57-9.306v-.002Z","stroke":"#234652"}})])
          )
        }
      }
    